<template>
  <validation-observer ref="simpleRules">
    <div>
      <b-card>
        <b-row>
          <b-col
            cols="12"
            md="4"
          >
            <category-card />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <products-title />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <products-pcode-card />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <brand-card />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <model-card />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <origins-card />
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <products-department-select />
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <products-team-select />
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <products-description-card />
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <products-notes-card />
          </b-col>
        </b-row>
      </b-card>
      <urls-card />
      <products-image-card />
      <b-alert
        v-if="!checkCodeResult.status"
        show
        variant="danger"
      >
        <div class="alert-body text-center">
          {{ checkCodeResult.message }}
        </div>
      </b-alert>
      <div v-else>
        <save-button
          :save-action="submitForm"
          :is-disabled="submitStatus"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import {
  BCard, BRow, BCol, BAlert,
} from 'bootstrap-vue'
import ProductsTitle from '@/views/Products/Elements/TitleCard.vue'
import ProductsPcodeCard from '@/views/Products/Elements/PcodeCard.vue'
import ProductsDepartmentSelect from '@/views/Products/Elements/DepartmentsCard.vue'
import ProductsTeamSelect from '@/views/Products/Elements/TeamsCard.vue'
import CategoryCard from '@/views/Products/Elements/CategoryCard.vue'
import ProductsDescriptionCard from '@/views/Products/Elements/DescriptionCard.vue'
import ProductsNotesCard from '@/views/Products/Elements/NotesCard.vue'
import BrandCard from '@/views/Products/Elements/BrandCard.vue'
import ModelCard from '@/views/Products/Elements/ModelCard.vue'
import OriginsCard from '@/views/Products/Elements/OriginsCard.vue'
import UrlsCard from '@/views/Products/Elements/UrlsCard.vue'
import ProductsImageCard from '@/views/Products/Elements/ImageCard.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'ProductsProductCard',
  components: {
    ValidationObserver,
    SaveButton,
    ProductsImageCard,
    ProductsNotesCard,
    ProductsDescriptionCard,
    ProductsTeamSelect,
    ProductsDepartmentSelect,
    ProductsPcodeCard,
    ProductsTitle,
    BrandCard,
    ModelCard,
    OriginsCard,
    CategoryCard,
    UrlsCard,
    BCard,
    BRow,
    BCol,
    BAlert,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    loading() {
      return this.$store.getters['products/loading']
    },
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
    saveData() {
      return this.$store.getters['products/dataSaveStatus']
    },
    checkCodeResult() {
      return this.$store.getters['products/checkCodeResult']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        // Yalnız yeni kayıtta listeye dön; güncellemede formda kal
        if (!this.$route.params.id) {
          this.$router.push('/app/products')
        }
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataItem()
    },
  },
  created() {
    this.getDataItem()
    localize('tr')
  },
  methods: {
    getDataItem() {
      if (this.$route.params.id) {
        this.$store.dispatch('products/getDataItem', this.$route.params.id)
          .then(response => {
            // Arşivdeki kayıt düzenlenemez; görüntüleme sayfasına yönlendir
            if (response && response.archived) {
              this.$router.replace(`/app/products/view/${this.$route.params.id}`)
              return
            }
            if (response && response.id_departments) {
              this.getTeams()
            }
          })
      }
    },
    getTeams() {
      if (this.dataItem.id_departments) {
        this.$store.dispatch('teams/getDataList', {
          select: [
            'teams.id AS id',
            'teams.title AS title',
          ],
          where: {
            'teams.status': 1,
            'teams.id_departments': this.dataItem.id_departments,
          },
        })
      } else {
        this.dataItem.id_teams = null
      }
    },
    submitForm() {
      this.submitStatus = true
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$store.dispatch('products/saveData', this.dataItem)
            .then(() => {
              this.submitStatus = false
            })
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
          this.submitStatus = false
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
